import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { AuthShell } from "@/components/auth/AuthShell";
import { errorMessage } from "@/components/auth/issues";
import { Button, TextField } from "@/components/ui/FormControls";
import { api } from "@/lib/api";

export function AdminAccessPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api("/auth/admin-invite/request", { method: "POST", json: { email: email.trim() } });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title="관리자 계정 설정" sub="관리자 이메일로 계정 활성화 또는 비밀번호 재설정 링크를 받습니다." footer={<Link to="/login?next=%2Fadmin">로그인으로 돌아가기</Link>}>
      <form onSubmit={submit} className="auth-form">
        <TextField label="관리자 이메일" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder="name@company.com" />
        {sent && <p role="status" className="note note-ok text-label">해당 관리자 이메일로 설정 링크를 요청했습니다. 받은편지함과 스팸함을 확인해 주세요. 최근 요청이 있으면 기존 메일의 링크를 사용해 주세요.</p>}
        {error && <p role="alert" className="note note-danger text-label">{error}</p>}
        <Button type="submit" variant="primary" fullWidth disabled={busy || !email.trim()}>{busy ? "요청 중…" : "설정 링크 받기"}</Button>
      </form>
    </AuthShell>
  );
}
